import React, { useCallback, useState, Fragment, useEffect } from 'react';
import { useDispatch } from 'redux-react-hook';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react'

// Redux
import { postPlaylists, putPlaylists } from 'store/modules/users/actions';

// Components
import Button from 'components/Button';
import CheckBox from 'components/CheckBox';
import Modal from 'components/Panel/Modal';
import TextField from 'components/TextField';
import CheckCircleIcon from 'components/Icon/CheckCircle';

const width = { width: 300 };

export default function PlaylistForm({ playlist, onCancel, onSave }) {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [publicValue, setPublic] = useState(false);
  const [errors, setErrors] = useState({});
  const onNameChange = useCallback((event) => setName(event.target.value));
  const onPublicChange = useCallback(() => setPublic(!publicValue), [publicValue]);
  const onSavePlaylist = useCallback(() => {
    const save = playlist ? putPlaylists : postPlaylists;
    const id = playlist && playlist.id;
    dispatch(save({ id, title: name, public: publicValue }))
      .then((response) => {
        if (onSave) {
          onSave(response.payload.playlist);
        }
      })
      .catch(({ data: { errors: failed }}) => {
        setErrors(failed);
      });
  }, [name, publicValue]);

  useEffect(() => {
    if (playlist) {
      setName(playlist.title);
      setPublic(playlist.public);
    }
  }, [playlist]);

  return (
    <Modal onClose={onCancel} style={width}>
      <I18n>
        {({ i18n }) => 
          <Fragment>
            <TextField
              label={i18n._(t`Playlist name`)}
              placeholder={i18n._(t`The name of your new playlist`)}
              value={name}
              onChange={onNameChange}
              errors={errors.title}
            />
            <CheckBox
              label={i18n._(t`Public playlist`)}
              onChange={onPublicChange}
              checked={publicValue}
              className="mt-4"
            />
          </Fragment>
        }
      </I18n>
      <div className="text-right mt-4">
        <Button onClick={onSavePlaylist} type="primary">
          <CheckCircleIcon className="fill-current inline-block mr-1" width={16} height={16} /> <Trans>Save</Trans>
        </Button>
        <Button onClick={onCancel} type="secondary" className="ml-2">
          <Trans>Cancel</Trans>
        </Button>
      </div>
    </Modal>
  );
}
